// Shopify's edge (Cloudflare) intermittently answers /cart/*.js with a 429 or an HTML bot
// challenge instead of JSON. This is worst on VPN and US traffic. jQuery's `dataType: "json"`
// turns that HTML into a "parsererror", so it lands on the error path — which previously only
// logged to the console and left every buy button greyed out until a full page reload.
//
// Rules this code follows, so a challenged request is never a dead end:
//   1. Retry transient failures with backoff (the challenge usually clears on retry).
//   2. If retries are exhausted, hand off to a NATIVE form POST to /cart/add. A full page
//      load either succeeds or renders Cloudflare's challenge, which the customer can solve.
//      An AJAX call can do neither, because the challenge can't be shown inside a fetch.
//   3. Always restore button state, so a manual re-click is possible in every case.
const CART_RETRY_DELAYS_MS = [600, 1800];

// Guards against a second cart mutation overlapping the first. Replaces the old approach of
// greying out every buy button on the page, which had no path back to an enabled state.
let cartRequestInFlight = false;

function cartRedirectTarget() {
  const themeSettings = /** @type {any} */ (window).themeSettings;
  const upsellRedirectEnabled = !themeSettings || themeSettings.enableUpsellRedirect !== false;
  return upsellRedirectEnabled ? "/pages/upsell" : "/checkout";
}

// A challenge/rate-limit looks like: HTML where JSON was expected, a 429/430, a 403 from the
// bot filter, a 5xx, or status 0 (request blocked outright). All are worth another attempt.
function isTransientCartFailure(jqXHR, textStatus) {
  const status = jqXHR ? jqXHR.status : 0;
  return (
    textStatus === "parsererror" ||
    textStatus === "timeout" ||
    status === 0 ||
    status === 403 ||
    status === 429 ||
    status === 430 ||
    status >= 500
  );
}

function postCartJson(url, data) {
  return new Promise(function (resolve, reject) {
    $.ajax({ type: "POST", url: url, data: data, dataType: "json", timeout: 15000 })
      .done(resolve)
      .fail(function (jqXHR, textStatus) {
        reject({ jqXHR: jqXHR, textStatus: textStatus });
      });
  });
}

function postCartJsonWithRetry(url, data, attempt) {
  attempt = attempt || 0;

  return postCartJson(url, data).catch(function (failure) {
    const canRetry =
      isTransientCartFailure(failure.jqXHR, failure.textStatus) && attempt < CART_RETRY_DELAYS_MS.length;

    if (!canRetry) throw failure;

    console.warn(
      "Cart request to " + url + " failed (" + failure.textStatus + "), retry " + (attempt + 1)
    );

    return new Promise(function (resolve) {
      setTimeout(resolve, CART_RETRY_DELAYS_MS[attempt]);
    }).then(function () {
      return postCartJsonWithRetry(url, data, attempt + 1);
    });
  });
}

// Last-resort escape hatch: a real form POST, which navigates the whole page.
function submitNativeCartAdd(variantId, variantAttribute, sellingPlan, returnTo) {
  const form = document.createElement("form");
  form.method = "post";
  form.action = "/cart/add";
  form.style.display = "none";

  const addField = function (name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  addField("form_type", "product");
  addField("utf8", "✓");
  addField("id", variantId);
  addField("quantity", "1");

  if (variantAttribute) addField("properties[Tickets]", variantAttribute);

  if (sellingPlan) {
    addField("selling_plan", sellingPlan);
    addField("properties[__subscription]", sellingPlan);
  }

  // return_to keeps us off /cart — the redirect handler further down this file bounces any
  // URL containing "cart" to /pages/tickets, which would otherwise swallow the result.
  addField("return_to", returnTo);

  document.body.appendChild(form);
  form.submit();
}

function clearCartAndAddProduct(variantId, quantity, variantAttribute, sellingPlan = null) {
  const data = {
    quantity: 1,
    id: variantId,
    properties: {
      Tickets: variantAttribute
    }
  };

  if (sellingPlan) {
    data.selling_plan = sellingPlan;
    data.properties.__subscription = sellingPlan;
  }

  const redirectTarget = cartRedirectTarget();

  // clear-then-add is kept so the basket still ends up holding a single entry. If the add is
  // what fails, the native fallback below completes it, so a cleared basket is never the
  // final state the customer is left with.
  return postCartJsonWithRetry("/cart/clear.js", {})
    .then(function () {
      return postCartJsonWithRetry("/cart/add.js", data);
    })
    .then(function () {
      window.location.href = redirectTarget;
      return true;
    })
    .catch(function (failure) {
      console.error("Cart request failed after retries; falling back to native form POST", failure);
      submitNativeCartAdd(variantId, variantAttribute, sellingPlan, redirectTarget);
      return false;
    });
}

$(document).ready(function () {
  // FAQ Accordion Toggle
  $(document).on("click", ".faq-title", function () {
    $(this)
      .parents(".faq-items-wrapper")
      .siblings(".faq-items-wrapper")
      .find(".faq-title")
      .removeClass("active");
    
    $(this).toggleClass("active");
    
    $(this)
      .parents(".faq-items-wrapper")
      .siblings(".faq-items-wrapper")
      .find(".accordion__content")
      .slideUp();
    
    $(this).next(".accordion__content").slideToggle();
  });

  // Product Card Buy Button Click
  // Delegated, so product cards rendered after page load (section re-render, lazy blocks)
  // still get a handler. And only the clicked button is greyed out — the previous version
  // disabled every buy button on the page, so one failed request killed all of them at once.
  $(document).on("click", ".product-card-wrapper .buy-button:not(.competition_ended) .button", function () {
    const $button = $(this);

    if (cartRequestInFlight || $button.hasClass("disabled")) return;

    cartRequestInFlight = true;
    $button.addClass("disabled");
    
    const variantId = $(this).attr("data-variant");
    const varAttribute = $(this).attr("data-tickets");
    const quantity = 1;
    const sellingPlan = $(this).attr("data-selling-plan");
    
    clearCartAndAddProduct(variantId, quantity, varAttribute, sellingPlan).finally(function () {
      // Runs on success, on failure, and on fallback handoff, so the button is never left
      // permanently dead the way it was when only console.error ran.
      cartRequestInFlight = false;
      $button.removeClass("disabled");
    });
  });

  // Video Text Button Click
  $(".video_text-btn").on("click", function () {
    $(this).parents(".row").find("video").trigger("play");
    $(this).parents(".row").find(".cover_image").hide();
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover video").trigger("pause");
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover .cover_image").show();
  });

  // Video Cover Play Button Click
  $(document).on("click", ".video-cover .cover_image .play-btn", function () {
    $(this).parents(".video-cover").find("video").trigger("play");
    $(this).parents(".video-cover").find(".cover_image").hide();
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover video").trigger("pause");
    $(this).parents(".video-items .slide__item").siblings().find(".video-cover .cover_image").show();
  });

  // Slideshow Slider (Slick)
  $(".slideShow-wrapper").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3112)"><path d="M24 1.80481L7 20.897L24 37.6608" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3112" x="0.931763" y="0.807251" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3112"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3112" result="shape"/></filter></defs></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3111)"><path d="M6 1.3241L23 20.4163L6 37.1801" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3111" x="0.879639" y="0.326538" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3111"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3111" result="shape"/></filter></defs></svg></button>',
    adaptiveHeight: true
  });

  // Video Slider (Slick)
  $(".video-slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: false,
    prevArrow: '<button type="button" class="slick-prev"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3112)"><path d="M24 1.80481L7 20.897L24 37.6608" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3112" x="0.931763" y="0.807251" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3112"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3112" result="shape"/></filter></defs></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="30" height="47" viewBox="0 0 30 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_393_3111)"><path d="M6 1.3241L23 20.4163L6 37.1801" stroke="white" stroke-width="3" shape-rendering="crispEdges"/></g><defs><filter id="filter0_d_393_3111" x="0.879639" y="0.326538" width="28.1885" height="45.9216" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_393_3111"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_393_3111" result="shape"/></filter></defs></svg></button>'
  });

  // Terms Accordion Toggle
  $(document).on("click", ".term-title", function (evnt) {
    evnt.preventDefault();
    
    const scrollDiv = $(this).attr("dataScroll");
    console.log(scrollDiv);
    
    $(this)
      .parents(".term-item-wrapper")
      .siblings(".term-item-wrapper")
      .find(".term-title")
      .removeClass("active");
    
    $(this).toggleClass("active");
    
    $(this)
      .parents(".term-item-wrapper")
      .siblings(".term-item-wrapper")
      .find(".accordion__content")
      .slideUp();
    
    $(this).next(".term-content").slideToggle();
    
    setTimeout(function () {
      $("body,html").animate({
        scrollTop: $(".term-title[datascroll='" + scrollDiv + "']").offset().top - 185
      }, 1000);
    }, 500);
  });
});

// Redirect cart and collections pages
$(document).ready(function () {
  const currentURL = window.location.href;
  
  if (currentURL.includes("cart")) {
    window.location.href = "/pages/tickets";
  }
  
  if (currentURL.includes("collections")) {
    window.location.href = "/pages/tickets";
  }
});

// Remove title attributes from all links
$(document).ready(function () {
  $("a").removeAttr("title");
});